module.exports = __webpack_public_path__ + "static/img/kbank.e41e3f6c.svg";